<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent,
        props: {
            ...DefaultComponent.props,
            inWidget: Boolean,
        },
        computed: {
            ...DefaultComponent.computed,
            language() {
                return this.item.language ? this.item.language : 'English';
            },
        }
    }
</script>

<template>
    <a :href="url" :target="target" :class="['card', 'booklink', 'is-shadowless', { 'is-flex-direction-column': inWidget }]">
        <div v-if="item.imageSets && item.imageSets.length" class="card-image is-flex-shrink-0">
            <source-set :imageSets="item.imageSets" />
        </div>
        <div class="card-content">
            <h3 v-show="item.title" :class="['title', titleClass]">{{ item.title }}</h3>
            <p v-show="!inWidget && item.isbn" class="has-text-grey-darker mb-2">{{ item.isbn }}</p>
            <p v-show="!inWidget && language" class="has-text-black is-size-body mb-2">{{ language }}</p>
            <p v-show="!inWidget && item.seriesTitle" class="has-text-black is-size-body has-text-weight-semibold mb-2">{{ item.seriesTitle }}</p>
            <p v-show="item.yearPublished" :class="['has-text-black', textClass]">{{ toMonthYearStr(item.yearPublished) }}</p>
        </div>
    </a>
</template>
